
// core components
import React from "react";
import StatusPageHeader from "../../../components/Headers/StatusPageHeader";

class Status500Page extends React.Component {
  render() {
    return (
      <>
        <StatusPageHeader
          title="500!"
          lead="Something went wrong. We are trying to get it fixed as soon as possible. Please try again later!"
          btnURL="/"
        />
      </>
    );
  }
}

export default Status500Page;
